import React from 'react'
import cx from 'classnames'
import actions from 'redux/actions'

import { Href } from 'components/_new/controls'

import s from './Link.scss'


type SEOLinkProps = {
  className?: string,
  to: string
}

const onClick = () => actions.view.smartSearchPage.closeFiltersOverlay()


const SEOLink: React.FunctionComponent<SEOLinkProps> = (props) => {
  const { children, className, to } = props

  return (
    <Href
      className={cx(s.link, className)}
      href={to}
      onClick={onClick}
    >
      {children}
    </Href>
  )
}

export default SEOLink
